<template>
  <article>
    <div ref="header">
      <div class="plarform-search">
        <a href="javascript:void(0);" class="search-icon" @click.stop="search"></a>
        <input v-model="mobile" type="text" class="search-number" placeholder="请输联系电话">
      </div>
      <div class="tab-service">
        <ul class="tab-service-detail">
          <li :class="{'on':status===1}" @click="onShiftTap(1)"><a href="javascript:void(0);">未联系</a></li>
          <li :class="{'on':status===2}" @click="onShiftTap(2)"><a href="javascript:void(0);">已联系</a></li>
          <li :class="{'on':status===3}" @click="onShiftTap(3)"><a href="javascript:void(0);">已预约</a></li>
          <li :class="{'on':status===6}" @click="onShiftTap(6)"><a href="javascript:void(0);">已到店</a></li>
          <li :class="{'on':status===4}" @click="onShiftTap(4)"><a href="javascript:void(0);">已休眠</a></li>
        </ul>
      </div>
    </div>

    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-for="(item, index) in allClues" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}</p>
            <i slot="value" class="phone-icon-right" @click.stop="makeACall(item.mobile)"></i>
          </cell>
          <cell class="personal-info-detail" @click.native="clueArchives(item.id)">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <p slot="after-title" class="info">下次致电：{{item.next_contact_at}}</p>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
          </cell>
        </group>
        <p class="tip-text1">共有{{totalCount}}条线索</p>
      </div>
    </scroller>

    <section class="btn-bottom">
      <div class="btn-fix" ref="footer">
        <a class="btn" href="javascript:void(0);" @click="addClueArchives()">新线索录入</a>
      </div>
    </section>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import util from '../../../common/util'
import cache from '../../../common/cache'
import authApi from '../../../common/auth'

export default {
  components: {
    Scroller,
    Cell,
    Group
  },
  data () {
    return {
      pageAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      status: 1,
      allClues: [],
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      mobile: '',
      scrollerHeight: ''
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight + this.$refs.footer.offsetHeight}px`
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      let permission = authApi.haveSomeAuth(this.pageAuth, authList)
      if (permission) {
        this.initQuery()
      }
    })
  },
  methods: {
    initQuery () {
      this.$rest.saleManage.allClues({
        status: this.status,
        page: this.page,
        item_per_page: this.item_per_page,
        mobile: this.mobile
      }).then(res => {
        if (res.code === 0) {
          this.allClues = res.data.clues
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        }
      })
    },
    onShiftTap (st) {
      if (st === this.status) return
      this.status = st
      this.page = 1
      this.totalPage = 1
      this.allClues = []
      this.initQuery()
    },
    makeACall (phone) {
      window.location.href = 'tel:' + phone
    },
    addClueRecord (id) {
      this.$router.push('/salemanage/staff/addcluerecord/' + id)
    },
    addClueArchives () {
      cache.clearSessionData('clueArchivesLocalData')
      this.$router.push({ path: '/salemanage/staff/cluearchives/' })
    },
    clueArchives (id) {
      if (id) {
        cache.clearSessionData('clueArchivesLocalData')
        this.$router.push({ path: '/salemanage/staff/cluearchives/', query: { id: id } })
      }
    },
    search () {
      if (!this.mobile) {
        this.showToast('请输入联系电话')
        return false
      } else if (!util.regexpMap.regexp_mobile.test(this.mobile)) {
        this.showToast('请输入正确的号码')
        return false
      }
      this.page = 1
      this.totalPage = 1
      this.allClues = []
      this.initQuery()
    },
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.allClues({
          status: this.status,
          page: this.page,
          item_per_page: this.item_per_page,
          mobile: this.mobile
        }).then(res => {
          if (res.code === 0) {
            this.allClues.push(...res.data.clues)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
